import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "../hooks/scrollToTop";
import FoundersPage from "../pages/about/FoundersPage";
import SigninPage from "../pages/account/SigninPage";
import SignupPage from "../pages/account/SignupPage";
import BrowsePage from "../pages/browse/BrowsePage";
import CheckoutPage from "../pages/CheckoutPage";
import ContactPage from "../pages/contact/ContactPage";
import DashboardPage from "../pages/dashboard/DashboardPage";
import FaqPage from "../pages/faq/FaqPage";
import HomePage from "../pages/HomePage";
import JournalsPage from "../pages/journal/JournalsPage";
import MeasurementPage from "../pages/measurements/MeasurementPage";
import ProductPage from "../pages/product/ProductPage";
import VerifyOwnershipPage from "../pages/VerifyOwnershipPage";

function Router() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/browse" element={<BrowsePage />} />
        <Route path="/product/:slug" element={<ProductPage />} />
        <Route path="/verify-ownership" element={<VerifyOwnershipPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/founder" element={<FoundersPage />} />
        <Route path="/journal" element={<JournalsPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/measurement" element={<MeasurementPage />} />
        <Route path="/signin" element={<SigninPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/faqs" element={<FaqPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default Router;
